module.exports = __webpack_public_path__ + "static/delegations-f38fe7c5bb6394553069d1da3eed508c.png";